if (!customElements.get('sultana-infinite-scroll')) {
  customElements.define('sultana-infinite-scroll', class extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section');
      this.grid = this.section.querySelector('product-list');
      this.nav = this.querySelector('nav');
      this.status = this.querySelector('[role="status"]');
      if (!this.grid || !this.nav || !('IntersectionObserver' in window)) return;
      this.seen = new Set([...this.grid.querySelectorAll('product-card')].map(card => card.getAttribute('handle')));
      this.visited = new Set();
      this.stopped = false;
      this.onFilter = () => { this.stopped = true; this.controller?.abort(); this.observer.disconnect(); };
      document.addEventListener('facet:update', this.onFilter, true);
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) this.load();
      }, {rootMargin: '0px 0px 500px 0px'});
      this.classList.add('is-enhanced');
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.stopped = true;
      this.controller?.abort();
      this.observer?.disconnect();
      document.removeEventListener('facet:update', this.onFilter, true);
    }
    async load() {
      const link = this.nav?.querySelector('a[rel="next"]');
      if (this.loading || this.stopped || !link) return;
      const url = new URL(link.href);
      url.searchParams.set('section_id', this.dataset.section);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      if (this.visited.has(url.href)) return;
      this.loading = true;
      this.controller = new AbortController();
      this.setAttribute('aria-busy', 'true');
      this.status.textContent = this.dataset.loading;
      const timer = setTimeout(() => this.controller.abort(), 20000);
      try {
        const response = await fetch(url, {signal: this.controller.signal});
        if (!response.ok) throw new Error('Request failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (this.stopped || !this.isConnected) return;
        const section = doc.getElementById(this.section.id);
        const incoming = section?.querySelector('product-list');
        const pager = section?.querySelector('sultana-infinite-scroll');
        if (!incoming || !pager) throw new Error('Invalid section');
        const cards = [...incoming.querySelectorAll(':scope > product-card')];
        if (!cards.length) throw new Error('Empty page');
        const fragment = document.createDocumentFragment();
        for (const card of cards) {
          const handle = card.getAttribute('handle');
          if (!handle || this.seen.has(handle)) continue;
          this.seen.add(handle);
          card.querySelectorAll('img').forEach(img => { img.loading = 'lazy'; });
          fragment.append(document.importNode(card, true));
        }
        this.grid.append(fragment);
        this.visited.add(url.href);
        const nextNav = pager.querySelector('nav');
        this.nav.replaceChildren(...(nextNav ? [...nextNav.childNodes].map(node => document.importNode(node, true)) : []));
        this.status.textContent = '';
        if (!this.nav.querySelector('a[rel="next"]')) {
          this.observer.disconnect();
          this.hidden = true;
        } else {
          this.observer.unobserve(this);
          this.observer.observe(this);
        }
      } catch (error) {
        if (!this.stopped) {
          this.status.textContent = this.dataset.error;
          this.classList.remove('is-enhanced');
          this.observer.disconnect();
        }
      } finally {
        clearTimeout(timer);
        this.loading = false;
        this.removeAttribute('aria-busy');
      }
    }
  });
}
